<template>
  <div ref="refMeetingTypeChipGroup" @click="onClick" style="width: 100%">
    <v-chip-group class="temp">
      <div v-if="!items.length" style="margin: auto">
        <span class="placeHolder">{{ $t("agenda.lblFilterMeetType") }}</span>
      </div>
      <v-chip
        v-else      
        small
        v-for="item in items"
        :key="item.label"
        close
      
        :color="item.color"
        label
        :style="textStyle(item.color)"
        @click:close="remove(item)"
      >
        {{ item.label }}
      </v-chip>
      <v-spacer></v-spacer>
      <meeting-type-menu-list
        v-model="items"
        :open.sync="openMeetingTypeMenu"
      ></meeting-type-menu-list>
    </v-chip-group>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions } from "vuex";
import MeetingTypeMenuList from "./MeetingTypeMenuList.vue";
import customFunctions from "@/codeFiles/taskHelper.js";
export default {
  components: { MeetingTypeMenuList },
  name: "MeetingTypeChipGroup",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedMeetingTypes: [],
      clientWidth: 0,
      openMeetingTypeMenu: false,
    };
  },
  computed: {
    items: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
    clientWidth(value) {
      this.setMeetingTypeFilterWidth(value);
    },
  },
  mounted,
  methods: {
    ...mapActions({
      setMeetingTypeFilterWidth: "agenda/setMeetingTypeFilterWidth",
    }),
    remove(item) {
      this.items = _.remove(this.items, (n) => n.label !== item.label);
    },
    onClick() {
      // this.$emit("open");
      this.openMeetingTypeMenu = true;
    },
    handleResize(event) {
      if (this.$refs.refMeetingTypeChipGroup) {
        this.clientWidth = this.$refs.refMeetingTypeChipGroup.clientWidth;
      }
    },
    textStyle(color){
      return customFunctions.getContrast(color)?'color:white':'color:black';
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};

function mounted() {
  this.clientWidth = this.$refs.refMeetingTypeChipGroup.clientWidth;
  window.addEventListener("resize", this.handleResize);
}
</script>

<style>
.v-chip-group .v-slide-group__content {
  padding: 4px !important;
}
.v-application--is-ltr .v-banner__wrapper {
  padding: 0px !important;
}

.v-chip-group .v-chip {
  margin: 2px 8px 2px 0 !important;
}

.temp {
  border: 1px solid white;
  border-radius: 28px;
  min-height: 28px;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 2px;
  margin-bottom: 2px;
}

.v-chip-group .v-slide-group__content {
  padding: 0px 0 !important;
}

.placeHolder {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
}
</style>